module.exports = __webpack_public_path__ + "static/services-img5-a89beca25a6de27db6e28a4c2cf2b3bc.png";